/*
Member Form Modal Validator
================================================================================
*/

/*
Imports
------------------------------------------------------------
*/
// app
import { validatorFactory } from 'utils/reduxForm';

/*
Schema
------------------------------------------------------------
*/
const schema = {
  cleaning: { presence: true },
  xray: { presence: true },
  exam: { presence: true },
  hygenist: { presence: true},
  supplies: { presence: true},
  memberCount: {presence: true}
};

export default validatorFactory(schema);
